import { useRef } from 'react';

export const useInitRef = <T>(initializer: () => T): T => {
	const ref = useRef<T | null>(null);
	const initialized = useRef(false);

	if (!initialized.current) {
		initialized.current = true;
		ref.current = initializer();
	}

	return ref.current as T;
};
